import { render } from "./DeleteEventCard.vue?vue&type=template&id=c3dc7146"
import script from "./DeleteEventCard.vue?vue&type=script&lang=js"
export * from "./DeleteEventCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__